import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import PracticeModel from "./models/PracticeModel";
import { IEstimateRequest } from "stores/estimate/EstimateEffect";

export interface IPracticeRequest {
    estimate: IEstimateRequest;
}

export default class PracticeEffect {
    public static async practice(request: IPracticeRequest): Promise<PracticeModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.practice;
        return EffectUtility.postToModel<PracticeModel>(PracticeModel, endpoint, request);
    }
}
